import {
  Hub,
  Sensor,
  useGetTopFiveElectricalEnergyUsage as useGetTopFiveElectricalEnergyUsageCommon,
} from "common";

import { useAppSync } from "../../contexts/AppSyncContext";

export interface EnergyUsageDevice {
  name: string;
  value: number;
  power: number;
}

export type DataProvider = {
  selectedHub: Hub;
  sensors: Sensor[];
};

export const useGetTopFiveElectricalEnergyUsage = () => {
  const { selectedHub, sensors } = useAppSync();
  return useGetTopFiveElectricalEnergyUsageCommon({ selectedHub, sensors });
};
